import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormGroupDirective } from '@angular/forms';
import { ValidationService } from 'src/app/core/services/validation.service';
import { AppService } from 'src/app/core/services/app.service';
import { API } from '../../../../core/constants';
import { ToastrService } from 'ngx-toastr';
import { SearchCountryField, CountryISO } from 'ngx-intl-tel-input-gg';
import { environment } from 'src/environments/environment';
const EMAIL_REGEX = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;

@Component({
  selector: 'app-pre-register',
  templateUrl: './pre-register.component.html',
  styleUrls: ['./pre-register.component.scss']
})
export class PreRegisterComponent implements OnInit {
  clientDetails: any;
  registerForm: FormGroup;
  separateDialCode = true;
  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  preferredCountries: CountryISO[] = [CountryISO.UnitedStates, CountryISO.UnitedKingdom];
  selectedCountry = 'US';
  @ViewChild(FormGroupDirective, { static: false }) formGroupDirective: FormGroupDirective;
  
  constructor(private formBuilder: FormBuilder,
    private appService: AppService,
    private toastr: ToastrService,) { }

  ngOnInit() {
    this.clientDetails = environment.clientDetails;
    this.registerForm = this.formBuilder.group({
      name: ['', Validators.required],
      email: ["", [Validators.required, ValidationService.emailValidator, Validators.pattern(EMAIL_REGEX)]],
      phone: ['', [Validators.required]],
      // message: ['', Validators.required],
      organization_name:['']
    });
  }

  get businessPhoneValue() {
    return this.registerForm.controls['phone'];
  }

  onSubmit() {
    if (this.registerForm.valid) {
      let url = API.CONTACT_US;
      let inputData = this.registerForm.value;
      inputData['type']="creator_pre_register";
      inputData['message']="Creator Pre Register request";
      let dial_code = (inputData.phone && inputData.phone.dialCode) ? inputData.phone.dialCode : '';
      inputData.phone = (inputData.phone && inputData.phone.number) ? inputData.phone.number.replace(/\W+/g, '') : '';
      inputData.phone = dial_code + inputData.phone;
      this.appService.postRequest(url, inputData).subscribe(result => {
        if (result.status == 0) {
          this.toastr.success(result.message);
          this.selectedCountry = 'US';
          setTimeout(() =>
            this.formGroupDirective.resetForm(), 0);
        }
      }, error => {
        console.log(error);
      })
    }
  }

}
